export default "__VITE_ASSET__Ber63ROQ__"